var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusVec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 4,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9231 6.92308C12.9231 6.4125 12.5106 6 12 6C11.4894 6 11.0769 6.4125 11.0769 6.92308V11.0769H6.92308C6.4125 11.0769 6 11.4894 6 12C6 12.5106 6.4125 12.9231 6.92308 12.9231H11.0769V17.0769C11.0769 17.5875 11.4894 18 12 18C12.5106 18 12.9231 17.5875 12.9231 17.0769V12.9231H17.0769C17.5875 12.9231 18 12.5106 18 12C18 11.4894 17.5875 11.0769 17.0769 11.0769H12.9231V6.92308Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusVec);
export default __webpack_public_path__ + "static/media/plus-vec.7ec972af588eca0bcd3e2faf67b57a52.svg";
export { ForwardRef as ReactComponent };